import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import 'react-datepicker/dist/react-datepicker.css';
import AddShippingAddressOverlayDialog from '../../dialogs/addShippingAddressOverlayDialog';
import ModalAddSerialNumberOverlayDialog from '../../dialogs/modalAddSerialNumberOverlayDialog';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import PriceSourceOverlayDialog from '../../dialogs/priceSourceOverlayDialog';
import { WARE_HOUSE_CODE_ERROR_MESSAGE, WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE } from '../../common/messageConstants';
import _ from 'lodash';
import moment from 'moment';

/* Actions */
import {
	setRequestReturnDetails,
	getRestockingFee,
	getShippingAddresses,
	getOrderableServices,
	saveOrderableServices,
	checkServicePrices,
	getPIMItemInfo
} from '../../../redux/actions';
import AddressSearchDialog from '../../dialogs/addressSearchDialog';

class RequestReturnStep2 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			requestReturnStep2Form: {
				params: {
					orderDate: moment().format('MM/DD/YYYY'),
					orderType: 'Return Order',
					deliveryMethod: 'I want products picked up',
					poNumber: '',
					deliveryInstructions: '',
					requestedDeliveryDate: this.props.add2BusinessDaysToToday(),
					deliveryPhone: '',
					billingAddress: '',
					shippingAddress: '',
					phoneNumber: '',
					warehouseCode: '',
					returnToAddress: '',

					accountNumber: '',
					agreementNumber: '',
					createdById: '',
					createdBy: '',
					email: '',
				},
				errors: {
					poNumberError: '',
					restockingPoNumError:'',
					deliveryPhoneError: '',
				},
			},
			// date: null,
			addressList: [],
			pickingUpAddressList: [],
			originalReturnToAddress: null,
			showAddShippingAddressOverlayDialog: false,
			showModalAddSerialNumberOverlayDialog: false,
			selectedSerialNumber: [],
			selectedIndex: null,
			originalSerialNumbers: [],
			showReturnMyself:true,
			showCratedAndServices : [],
			isSdsLoc : false,
			defaultShippingAddress: null,
			selectedSKU: '',
			selectedSKUIndex: '',
			showAddServicesOverlayDialog: false,
			availableServices: null,
			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			showPriceSourceOverlayDialog: false,
			showSelectPriceSourceOverlayDialog: false,
			selectedPriceSource: null,
			returnProductsMyself: false,
		};
		// this.handleChange = this.handleChange.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.updateReturnToAddress = this.updateReturnToAddress.bind(this);
		this.checkASMOrIsInDL = this.checkASMOrIsInDL.bind(this);
		this.manageAvailableServices = this.manageAvailableServices.bind(this);
		this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
		this.getDeliveryMethod = this.getDeliveryMethod.bind(this);
		this.getLocTypeAccordingToDeliveryMethod = this.getLocTypeAccordingToDeliveryMethod.bind(this);
		this.getShippingAddressState = this.getShippingAddressState.bind(this);
		this.setAttribute6 = this.setAttribute6.bind(this);
		this.showServicesColumn = this.showServicesColumn.bind(this);
		this.showCratedColumn = this.showCratedColumn.bind(this);
		this.handleSelectedServices = this.handleSelectedServices.bind(this);
		this.resetSelectedSKU = this.resetSelectedSKU.bind(this);
		this.handleShowServiceDescription = this.handleShowServiceDescription.bind(this);
		this.handleActionChangeService = this.handleActionChangeService.bind(this);
		this.resetSelectedServices = this.resetSelectedServices.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		// Redirect to request return page if there is no data in store, it means page is refreshed
		if(!this.props.order.requestReturnDetails) {
			browserHistory.push("/requestreturn");
		} else {
			const self = this;
			const { userDetails, jobSiteAddressList } = self.props.user;
			const orderDetails = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
			const orderHeaderAttribute = self.props.order.requestReturnList && self.props.order.requestReturnList.responseObject[0];
			const shippingAddressDeatils = self.props.order.orderDetails.responseObject.shippingAddress ;
			// get picking up address
			const addressList = self.props.getCombinedAddresses();
			// WCP-7622: Append job site address to address list so it can prepopulate
			if (orderDetails.shippingAddress.address4 === 'JOB SITE') {
				const jobSiteAddress = jobSiteAddressList.find(item => item.LOCATIONID.toString() === orderDetails.shippingAddress.locationId);
				if (jobSiteAddress) {
					addressList.push(jobSiteAddress);
				}
			}
			let showCratedAndServices = [];
			if(orderDetails && orderDetails.items && orderDetails.items.length > 0){
				orderDetails.items.forEach(item =>{
					let val = item.replacementNeeded ?  true : false
					showCratedAndServices.push(val);
				})
			}
			let addressList1 = addressList.filter(item => item.PURPOSE === 'SHIP_TO');
			let shippingAddress = JSON.stringify(_.find(addressList1, {ADDRESS1: orderDetails.shippingAddress.address1}));
			// WCP-7622: we need to default the original address in all scenarios.
			// So here we are checking if no shipping address then we need to append it to list
			if (!shippingAddress) {
				shippingAddress= JSON.stringify({
					NAME: orderDetails.shippingAddress.addressName,
					ADDRESS1: orderDetails.shippingAddress.address1,
					ADDRESS2: orderDetails.shippingAddress.address2,
					CITY: orderDetails.shippingAddress.city,
					STATE: orderDetails.shippingAddress.state,
					POSTALCODE: orderDetails.shippingAddress.zip,
					SITE_USE_ID: orderDetails.shippingAddress.addressId,
				});
				addressList.push({
					NAME: orderDetails.shippingAddress.addressName,
					ADDRESS1: orderDetails.shippingAddress.address1,
					ADDRESS2: orderDetails.shippingAddress.address2,
					CITY: orderDetails.shippingAddress.city,
					STATE: orderDetails.shippingAddress.state,
					POSTALCODE: orderDetails.shippingAddress.zip,
					SITE_USE_ID: orderDetails.shippingAddress.addressId,
					PURPOSE: 'SHIP_TO'
				});
				addressList1.push({
					NAME: orderDetails.shippingAddress.addressName,
					ADDRESS1: orderDetails.shippingAddress.address1,
					ADDRESS2: orderDetails.shippingAddress.address2,
					CITY: orderDetails.shippingAddress.city,
					STATE: orderDetails.shippingAddress.state,
					POSTALCODE: orderDetails.shippingAddress.zip,
					SITE_USE_ID: orderDetails.shippingAddress.addressId,
					PURPOSE: 'SHIP_TO'
				});
			}
			let pickingUpAddressList = addressList;
			if(pickingUpAddressList) {
				pickingUpAddressList = addressList.filter(item => item.PURPOSE === 'SHIP_TO');
				pickingUpAddressList = _.orderBy(pickingUpAddressList, ['PRIMARYINDICATOR'], ['desc']);
			}
			const {state, zip} = shippingAddressDeatils;
			const zipValue = zip.split("-")[0];
			const { selectedAccount } = self.props.user;
			const userShippingAddress = self.props.user.selectedAddress && JSON.parse(self.props.user.selectedAddress).PURPOSE === 'SHIP_TO'
										? JSON.parse(self.props.user.selectedAddress)
										: {};
			const defaultShippingAddress = shippingAddressDeatils || {
					name: selectedAccount.ORGANIZATIONNAME,
				    address1: userShippingAddress.ADDRESS1,
				    address2: "",
					address3: "",
					address4: "",
				    city: userShippingAddress.CITY,
				    state: userShippingAddress.COUNTRY === "US" ? userShippingAddress.STATE : null,
				    zip: userShippingAddress.POSTALCODE,
					phone: '',
					addressId: userShippingAddress.SITE_USE_ID,
					county: userShippingAddress.COUNTY,
					country:userShippingAddress.COUNTRY,
				}
			self.setState({
				addressList: addressList1,
				defaultShippingAddress,
				showCratedAndServices,
				pickingUpAddressList,
				requestReturnStep2Form: {
					...self.state.requestReturnStep2Form,
					params: {
						...self.state.requestReturnStep2Form.params,
						shippingAddress,
						originalShippingAddress: shippingAddress ? JSON.stringify(JSON.parse(shippingAddress)) : '',
						billingAddress: orderDetails.billingAddress,
						accountNumber: self.props.getSelectedAccountNumber(),
						agreementNumber: orderDetails.agreementNumber,
						createdById: userDetails.sso,
						createdBy: userDetails.firstName + " " + userDetails.lastName,
						email: userDetails.email,
					}
				}
			}, () => {
				// get return to address
				if(zipValue) {	
				self.props.getShippingAddressesDetails(zipValue, false, "return_loc", (resp) => {
					const { shippingAddressDetailsListWithZipCode } = this.props.user;
					let shippingAddressDetail = _.find(shippingAddressDetailsListWithZipCode, {zipCode: zipValue});
					if(shippingAddressDetail){
						const foundSdsWillCall = shippingAddressDetail.details.findIndex(item => {
							return item.loctype == "sds_will_call_loc"
						});
						if(foundSdsWillCall != -1){
							this.setState({
								showReturnMyself:true
							})
						}else{
							this.setState({
								showReturnMyself:false
							})
						}
					}
						let warehouseCode = resp && resp.agentid,
							returnToAddress = '';
						if(resp && resp.agentid) {
							returnToAddress = {
								name: resp.dockname,
								address1: resp.dockaddr,
								address2: "",
								city: resp.dockcity,
								state: resp.dockst,
								zip: resp.dockzip,
								phone: resp.dockphone,
								warehouseCodeMessage : resp.locationAddressErrorMessage ==  WARE_HOUSE_CODE_ERROR_MESSAGE ? WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE : ""
							};
						} else {
							returnToAddress = '';
							warehouseCode = '';
						}
						self.setState({
							originalReturnToAddress: returnToAddress ? JSON.stringify(returnToAddress) : returnToAddress,
							requestReturnStep2Form: {
								...self.state.requestReturnStep2Form,
								params: {
									...self.state.requestReturnStep2Form.params,
									warehouseCode,
									returnToAddress
								}
							}
						});
					},true,state)
				}
				// self.updateReturnToAddress(zipCode);
				let country = "US";
				let zip = orderDetails.shippingAddress.zip;
				const numericRegex = /^[0-9]*$/;
				if (zip && zip.indexOf(' ') !== -1 && !numericRegex.test(zip)) {					
					country = "CA"
				}
				let zipVal = zip.split('-');
				zip = (zipVal && zipVal.length > 0) ? zipVal[0] : null;
				self.props.getShippingAddresses(`zip=${zip}&accountNumber=${self.props.getSelectedAccountNumber()}&country=${country}`, true, (resp) => {
					let sdsLocObject;
					if(resp.status && resp.responseObject) {
						sdsLocObject = _.find(resp.responseObject, ["loctype", "sds_loc"]);
						/* if(!sdsLocObject){
							sdsLocObject = _.find(resp.responseObject, ["loctype", "sds_will_call_loc"]);
						} */
					} 
					
					this.setState({
						isSdsLoc : !!sdsLocObject
					})


				});
			});
		}
	}

	updateReturnToAddress(zipCode, selectedAddress, callBack) {
		const self = this;
		//const {state} = selectedAddress;
		const state = JSON.parse(selectedAddress).STATE;
		// const shippingAddress = JSON.parse(self.state.requestReturnStep2Form.params.shippingAddress);
		//Make shipping service call to get picking up by address
		if(zipCode) {
			self.props.getShippingAddressesDetails(zipCode, false, "return_loc", (resp) => {
				const { shippingAddressDetailsListWithZipCode } = this.props.user;
				let shippingAddressDetail = _.find(shippingAddressDetailsListWithZipCode, {zipCode: zipCode});
				if(shippingAddressDetail){
					const foundSdsWillCall = shippingAddressDetail.details.findIndex(item => {
						return item.loctype == "sds_will_call_loc"
					});
					if(foundSdsWillCall != -1){
						this.setState({
							showReturnMyself:true
						})
					}else{
						this.setState({
							showReturnMyself:false
						})
					}
				}
				let warehouseCode = resp && resp.agentid,
					returnToAddress = '';
				if(resp && resp.agentid) {
					returnToAddress = {
						name: resp.dockname,
						address1: resp.dockaddr,
						address2: "",
						city: resp.dockcity,
						state: resp.dockst,
						zip: resp.dockzip,
						phone: resp.dockphone,
						warehouseCodeMessage : resp.locationAddressErrorMessage ==  WARE_HOUSE_CODE_ERROR_MESSAGE ? WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE : ""
					};
					if(self.state.requestReturnStep2Form.params.originalShippingAddress === selectedAddress) {
						// if(self.state.requestReturnStep2Form.params.shippingMethod === 'Meet Truck' || self.state.requestReturnStep2Form.params.shippingMethod === 'SDS Delivery') {
						// 	warehouseCode = self.state.requestReturnStep2Form.params.warehouseCode;
						// }
						// if(self.state.requestReturnStep2Form.params.shippingMethod === 'ADC Truckload' || self.state.requestReturnStep2Form.params.shippingMethod === 'ADC LTL') {
							warehouseCode = resp && resp.agentid;
						// }
					}
				} else {
					returnToAddress = '';
					if(self.state.requestReturnStep2Form.params.originalShippingAddress === self.state.requestReturnStep2Form.params.shippingAddress) {
						// if(!(self.state.requestReturnStep2Form.params.shippingMethod === 'Meet Truck' || self.state.requestReturnStep2Form.params.shippingMethod === 'SDS Delivery')) {
							warehouseCode = '';
						// }
					}
				}
				self.setState({
					requestReturnStep2Form: {
						...self.state.requestReturnStep2Form,
						params: {
							...self.state.requestReturnStep2Form.params,
							warehouseCode,
							returnToAddress
						}
					}
				}, () => {
					callBack && callBack();
				})
			},true,state)
		}
	}

	onChangeUpdateParam(event) {
        var self = this;
		const value = event.target.name === 'poNumber' ? event.target.value.toUpperCase() : event.target.value,
			name = event.target.name;
		// event.target.value = value;
		const orderDetails = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
		let errors = self.state.requestReturnStep2Form.errors,
			shippingAddress = self.state.requestReturnStep2Form.params.shippingAddress,
			returnToAddress = self.state.requestReturnStep2Form.params.returnToAddress,
			originalReturnToAddress = self.state.originalReturnToAddress && JSON.stringify(JSON.parse(self.state.originalReturnToAddress));
		if(name === 'deliveryMethod') {
			if(value === 'I will return the products myself') {
				shippingAddress = JSON.stringify(_.find(self.state.addressList, {ADDRESS1: orderDetails.shippingAddress.address1}));
				returnToAddress = originalReturnToAddress ? JSON.parse(originalReturnToAddress) : originalReturnToAddress;
				self.setState({
					returnProductsMyself: true
				})
			}
		}
		if(name === 'shippingAddress') {
			let site_Id = value;
			let pickingUpAddress = self.state.pickingUpAddressList;
			const selectedAddr = pickingUpAddress.find((addr)=>addr.SITE_USE_ID==site_Id);
			let shipAddress = selectedAddr;
			if(shipAddress){
				orderDetails.shippingAddress = {
					name: shipAddress.NAME,
					address1: shipAddress.ADDRESS1,
					address2: "",
					city: shipAddress.CITY,
					state: shipAddress.STATE,
					zip: shipAddress.POSTALCODE,
					phone: '',
					addressId: shipAddress.SITE_USE_ID,
				};
				this.resetSelectedServices()
			}
			const selectedZipCode = shipAddress.POSTALCODE;
			self.updateReturnToAddress(selectedZipCode.split("-")[0], JSON.stringify(shipAddress), () => {
				self.setState({
					requestReturnStep2Form: {
						...self.state.requestReturnStep2Form,
						params: {
							...self.state.requestReturnStep2Form.params,
							[name]: JSON.stringify(shipAddress),
							shipAddress,
						},
						errors
					}
		        }, () => {
					if(self.state.requestReturnStep2Form.errors[name + 'Error']) {
						self.setState({
							requestReturnStep2Form: {
								...self.state.requestReturnStep2Form,
								errors: {
									...self.state.requestReturnStep2Form.errors,
									[name+"Error"]: ""
								}
							}
				        });
					}
					// if(value === 'I will return the products myself') {
					// 	const zipCode = orderDetails.shippingAddress && (orderDetails.shippingAddress.zip || orderDetails.shippingAddress[0].zip);
					// 	self.updateReturnToAddress(zipCode);
					// }
				});
			});
		} else {
			if(event.target.name == "restockingPoNum"){
				orderDetails["restockingPoNum"] = event.target.value;
			}
			self.setState({
				requestReturnStep2Form: {
					...self.state.requestReturnStep2Form,
					params: {
						...self.state.requestReturnStep2Form.params,
						[name]: value,
						shippingAddress,
						returnToAddress
					},
					errors
				}
	        }, () => {
				if(self.state.requestReturnStep2Form.errors[name + 'Error']) {
					self.setState({
						requestReturnStep2Form: {
							...self.state.requestReturnStep2Form,
							errors: {
								...self.state.requestReturnStep2Form.errors,
								[name+"Error"]: ""
							}
						}
			        });
				}
				// if(value === 'I will return the products myself') {
				// 	const zipCode = orderDetails.shippingAddress && (orderDetails.shippingAddress.zip || orderDetails.shippingAddress[0].zip);
				// 	self.updateReturnToAddress(zipCode);
				// }
			});
		}
    }

	componentWillMount() {
		const orderDetails = this.props.order.requestReturnDetails && this.props.order.requestReturnDetails.responseObject;
		if(orderDetails) {
			if(orderDetails.oldShipMethod && orderDetails.deliveryMethod == 'I want products picked up' || orderDetails.deliveryMethod == 'I will return the products myself'){
				orderDetails.deliveryMethod = orderDetails.oldShipMethod;
			}
			// Add 2 business days for requested delivery date
			let poNumber = orderDetails.poNumber.indexOf('RET-') !== 0 ? `RET-${orderDetails.poNumber}` : orderDetails.poNumber;
			let restockingPoNum = orderDetails.restockingPoNum?orderDetails.restockingPoNum : `REST RET-${orderDetails.poNumber}`;
			poNumber = poNumber.substring(0, 50);
			this.setState({
				requestReturnStep2Form: {
					...this.state.requestReturnStep2Form,
					params: {
						...this.state.requestReturnStep2Form.params,
						poNumber,
						restockingPoNum,
						deliveryInstructions: orderDetails.deliveryInstructions,
						deliveryPhone: this.props.normalizePhoneNumber(orderDetails.deliveryPhone),
						shippingMethod: orderDetails.shippingMethod,
						deliveryMethod: (orderDetails.deliveryMethod === "I want products picked up" || orderDetails.deliveryMethod === "I will return the products myself" ? orderDetails.deliveryMethod : this.state.requestReturnStep2Form.params.deliveryMethod),

						phoneNumber: orderDetails.phoneNumber,
						returnToAddress: orderDetails.returnToAddress,

						accountNumber: orderDetails.accountNumber,
						agreementNumber: orderDetails.agreementNumber,
					}
				}
			});
		}
	}

	onDeleteItem(index, event) {
		event.preventDefault();
		const orderDetails = this.props.order.requestReturnDetails;
		orderDetails.responseObject.items.forEach((item, indx) => {
			if(index === indx) {
				delete item.selected; // updatedItems.push(item);
			}
		});
		// orderDetails.responseObject.items = updatedItems;
		this.props.setRequestReturnDetails(orderDetails);
	}

	onBlurValidatePhoneNumber(event) {
		var self = this,
			requestReturnStep2Form = this.state.requestReturnStep2Form;

        //Reset Error flag first
    	requestReturnStep2Form.errors.deliveryPhoneError = "";

        //Update current value
		requestReturnStep2Form.params.deliveryPhone = event.target.value;

		if(requestReturnStep2Form.params.deliveryPhone !== "" && self.props.isValidPhoneNumber(requestReturnStep2Form.params.deliveryPhone)) {
			requestReturnStep2Form.errors.deliveryPhoneError = "";
			var formattedNum = self.props.normalizePhoneNumber(event.target.value);
			requestReturnStep2Form.params.deliveryPhone = formattedNum;
			event.target.value = formattedNum;
		}

        self.setState({
            requestReturnStep2Form
        });
	}

	onChangeUpdateItems(indx, event) {
		let orderDetails = this.props.order.requestReturnDetails;
		let value = event.target.value;
		orderDetails.responseObject.items.forEach((item, index) => {
			if(indx === index) {
				item[event.target.name] = event.target.type === 'checkbox'?event.target.checked:event.target.value;
				if(event.target.name === 'reasonCategory') {
					item.reasonCategoryError = '';
					item.returnReasonCodeError = '';
					item.returnReasonCode = '';
				}
				if(event.target.name === 'returnReasonCode') {
					item.returnReasonCodeError = '';
				}
				// if(event.target.name === 'notes') {
				// 	item.notesError = "";
				// }
				if(event.target.name === 'serialNumber') {
					item.serialNumberError = "";
				}
				if(event.target.name === 'replacementNeeded') {
					let showCratedAndServices = this.state.showCratedAndServices;
					showCratedAndServices[index] = item.replacementNeeded;
					this.setState((prevState) => ({
						...prevState, 
						showCratedAndServices
					  }));
				}
				
				if(event.target.name === 'uncrateInd'){
					item[event.target.name] = value;
					if(value == "Y"){
						this.setAttribute6(item);
					}
				}
			}
		});
		this.props.setRequestReturnDetails(orderDetails);
	}


	showCratedColumn(item, index){
		this.setAttribute6(item);
		if(this.state.isSdsLoc && this.state.showCratedAndServices[index])
			return true;
		return false;
	}

	showServicesColumn(item, itemLevelDisableUncrateDropdown,index){
		if(this.state.isSdsLoc && item.onHold !== 'Y' && 
		(item.replacementNeeded || this.state.showCratedAndServices[index]) &&
		(!itemLevelDisableUncrateDropdown || 
			(itemLevelDisableUncrateDropdown && item.uncrateInd === "Y")))
			return true;
		return false;
	}
	
	setAttribute6(item){
		if(item.uncrateInd == "Y"){
			let { attribute } = item;
			attribute = attribute ? _.find(attribute, ['name', 'Attribute6']) : null;
			if(attribute){
				attribute.value = "U";
			}
		}
	}

	getShippingAddressZipCode() {
		const self = this;
		const { defaultShippingAddress } = self.state;
		const { shippingAddress } = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
		if(shippingAddress && shippingAddress.zip) {
			return shippingAddress.zip.split("-")[0];
		}
		return defaultShippingAddress.zip && defaultShippingAddress.zip.split("-")[0];
	}

	getDeliveryMethod() {
		const self = this;
		let { deliveryMethod } = self.props.order.requestReturnDetails.responseObject;
		if(deliveryMethod == 'I want products picked up' || deliveryMethod == 'I will return the products myself')
			deliveryMethod = self.props.order.requestReturnDetails.responseObject.oldShipMethod || 'SDS Delivery';
		return deliveryMethod || 'SDS Delivery';
	}

	getLocTypeAccordingToDeliveryMethod(deliveryMethod) {
		const record = _.find(this.props.order.pickAgentId, {deliveryMethod: deliveryMethod || this.getDeliveryMethod()});
		return record && record.loctype ? record.loctype : null;
	}

	getShippingAddressState() {
		const self = this;
		const { defaultShippingAddress } = self.state;
		const { shippingAddress } = self.props.order.requestReturnDetails.responseObject;
		if(shippingAddress && shippingAddress.zip) {
			return shippingAddress.state;
		}
		return defaultShippingAddress.state;
	}

	handleShowServiceDescription(serviceDetails, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			genericDialogHeading: "Service",
            genericDialogText: serviceDetails.serviceId + " - " + serviceDetails.serviceName,
            modalButtons: 'ok'
		}, () => {
			self.handleDialog("GenericOverlayDialog", true);
		});
	}

	handlePriceSourceDialog(selectedPriceSource, dialog, flag, selectedItem, event) {
		event && event.preventDefault();
		this.setState({
			selectedPriceSource,
			selectedItem
		}, () => {
			this.handleDialog(dialog, flag, event);
		});
	}

	manageAvailableServices(finalData, sku, zipCode) {
		const self = this;
		const availableServices = _.find(finalData, {sku, zipCode});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true);
		})
	}

	resetSelectedSKU() {
		var self = this;
		setTimeout(() => {
			self.setState({
				selectedSKU: '',
				selectedSKUIndex: '',
			})
		}, 1000);
	}

	handleSelectedServices(serviceData, skuList, selectedSKUIndex, uncrateInd) {
		var self = this,
			orderDetails = self.props.order.requestReturnDetails,
			items = orderDetails.responseObject.items,
			scrollToItemIndex = 0;
	    items.map((item, index) => {
			if(index === selectedSKUIndex) {
				scrollToItemIndex = index;
                if(skuList) {
                    item.relatedServices = skuList;
                }
				if(item.relatedServices.length === 0) {
					delete item.relatedServices;
				}
				item.uncrateInd = uncrateInd;
			}
			return null;
		})
		self.props.setRequestReturnDetails(orderDetails);
		self.setState({
			showAddServicesOverlayDialog: false,
			
		}, () => {
			//window.scrollTo(0, self.getElementOffset("quantity"+scrollToItemIndex));
			self.resetSelectedSKU();
		});
	}

	resetSelectedServices() {
		var self = this,
			orderDetails = self.props.order.requestReturnDetails,
			items = orderDetails.responseObject.items;
	    items.map((item, index) => {
			item.relatedServices = [];
			return null;
		})
		self.props.setRequestReturnDetails(orderDetails);
	}

	handleActionChangeService(index, serviceId, event) {
		event && event.preventDefault();
		const self = this,
			orderDetails = self.props.order.requestReturnDetails,
			items = orderDetails.responseObject.items;
		items.map((item, indx) => {
			if(index === indx) {
				item.relatedServices = _.pullAllBy(item.relatedServices, [{'serviceId': serviceId}], 'serviceId');
				item.uncrateInd = item.relatedServices.length === 0 ? 'N' : 'Y';
			}
			return null;
		})
		self.props.setRequestReturnDetails(orderDetails);
	}

	handleAddServices(index, item, itemLevelDisableUncrateDropdown, event) {
		event.preventDefault();
		const self = this,
		 orderDetails  = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
		self.setState({
			itemLevelDisableUncrateDropdown,
			selectedSKU: item,
			selectedSKUIndex: index,
		}, () => {
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
				if(resp && resp.agentid) {
					const record = _.find(self.props.order.orderableServices, {sku: item, zipCode: self.getShippingAddressZipCode()});
						if(record) {
							self.manageAvailableServices(self.props.order.orderableServices, item, self.getShippingAddressZipCode());
						} else {
							const { deliveryMethod } = orderDetails;
							const itemnumbers = orderDetails.items.filter(item => item.item === self.state.selectedSKU).map(item => item.item);
							self.props.getOrderableServices({
								OrderabilityRequest: {
									inventoryorg: resp.agentid,
									zipcode: self.getShippingAddressZipCode(),
									shipmethod: deliveryMethod,
									itemnumbers: _.uniq(itemnumbers)
								}
							}, "requestType=getOrderableServices", response => {
								if(response.status) {
									const orderableServices = JSON.parse(JSON.stringify(response));
									const { selectedAccount, selectedPriceSource } = self.props.user;
									const servicesPayload = [];
									const { shippingAddress } = self.props.order.requestReturnDetails.responseObject;
									const { defaultShippingAddress } = self.state;
									const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
									response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
										if(item.service.length === 4 && item.service.indexOf("M") === 0) {
											servicesPayload.push({
												pricingEffectiveDate: moment().format('YYYYMMDD'),
												accountNumber,
												state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
												whse: resp.agentid,
												zone: resp.sdsApZone,
												salesAgreementNumber,
												itemNumber: item.service
											});
										}
									});
									self.setState({
										requiredPayloadForServicePricing: {
											pricingEffectiveDate: moment().format('YYYYMMDD'),
											accountNumber,
											state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
											whse: resp.agentid,
											zone: resp.sdsApZone,
											salesAgreementNumber,
											postalCode: shippingAddress.zip.split("-")[0],
											country: shippingAddress.country ? shippingAddress.country : "US"
										}
									}, () => {
										if(servicesPayload.length > 0) {
											// Get all orderable services prices list
											
											self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
												if(resp.status) {
													// let orderableServices = self.props.state.order.orderableServices;
													// TO DO : Temporary conversion from json string to json
													resp.responseObject = JSON.parse(resp.responseObject);
													const orderableServicesTemp = [];
													orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
														let record = _.find(resp.responseObject.items, {itemNumber: item.service});
														// record.unitPrice = 200;
														if(record && (record.unitPrice || record.unitPrice === 0)) {
															orderableServicesTemp.push({
																...item,
																servicePrice: record.unitPrice,
																serviceDescription: item.description,
															});
														}
													});
													let finalData = [];
													self.props.order.requestReturnDetails.responseObject.items.forEach(itm => {
														if (itm.item === self.state.selectedSKU) {
															finalData.push({
																sku: itm.item,
																services: _.filter(orderableServicesTemp, {itemnumber: itm.item}),
																zipCode: self.getShippingAddressZipCode()
															});
														}
													});
													let existingOrderableServices = self.props.order.orderableServices;
													existingOrderableServices = existingOrderableServices.filter(it => it.sku !== self.state.selectedSKU);
													existingOrderableServices = existingOrderableServices.concat(finalData);
													self.props.saveOrderableServices(existingOrderableServices);
													self.manageAvailableServices(finalData, self.state.selectedSKU, self.getShippingAddressZipCode());
												} else {
													browserHistory.push("/error");
												}
											})
										} else {
											let finalData = [];
											self.props.order.requestReturnDetails.responseObject.items.forEach(itm => {
												finalData.push({
													sku: itm.item,
													services: [],
													zipCode: self.getShippingAddressZipCode()
												})
											})
											self.manageAvailableServices(finalData, self.state.selectedSKU, self.getShippingAddressZipCode());
										}
									});
								} else {
									browserHistory.push("/error");
								}
							});
						}

				}
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber());
		});
	}

	getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

	handleSubmitStep2(event) {
		event.preventDefault();
		var self = this,
            requestReturnStep2Form = self.state.requestReturnStep2Form,
            formError = false;
		const returnToAddress = self.state.requestReturnStep2Form.params.returnToAddress;
		if(returnToAddress && returnToAddress.warehouseCodeMessage == WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE){
			window.scrollTo(0, self.getElementOffset("addressDetails"));
			return;
		}
		const accessoryList = self.props.order.requestReturnPimdata.filter(item=>item.geego_accessory_indicator == "Y").map(filteredItem => filteredItem.product_attr_val_disp);
        for(var key in requestReturnStep2Form.errors) {
            if(!requestReturnStep2Form.params[key.replace("Error","")]) {
                requestReturnStep2Form.errors[key] = 'error';
                formError = true;
            }
        }

		// Check for phone number validity
		if(requestReturnStep2Form.params.deliveryPhone !== "" && !self.props.isValidPhoneNumber(requestReturnStep2Form.params.deliveryPhone)) {
			formError = true;
			requestReturnStep2Form.errors.deliveryPhoneError = "error";
		}
		// Check for notes, reason type or reason for return request in items
		const orderDetails = self.props.order.requestReturnDetails;
		orderDetails && orderDetails.responseObject && orderDetails.responseObject.items.forEach((item, index) => {
			if(item.selected) {
				/*if(!item.notes) {
					item.notesError = "error";
					formError = true;
				} else {
					item.notesError = ""
				}*/
				if(!item.serialNumber && !accessoryList.includes(item.item)) {
					item.serialNumberError = "error";
					formError = true;
				} else if(item.originalSerialNumbers && item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) {
					formError = true;
					item.serialNumberError = "error";
				} else if(!item.originalSerialNumbers && !accessoryList.includes(item.item)) {
					const enteredSerialNumbers = item.serialNumber.split(",");
					const actualCorrectSerialNumbers = [];
					enteredSerialNumbers.forEach(itm => {
						if(itm.trim()) {
							if(itm.trim().indexOf(" ") !== -1) {
								formError = true;
								item.serialNumberError = "error";
							}
							actualCorrectSerialNumbers.push(itm.trim());
						}
					});
					if(actualCorrectSerialNumbers.length !== parseInt(item.returnQuantity, 10) || (item.serialNumber && item.serialNumber.trim()[item.serialNumber.trim().length - 1] === ',')) {
						formError = true;
						item.serialNumberError = "error";
					}
				} else {
					item.serialNumberError = ""
				}
				if(!item.reasonCategory) {
					item.reasonCategoryError = "error";
					formError = true;
				} else {
					item.reasonCategoryError = ""
				}
				if(!item.returnReasonCode) {
					item.returnReasonCodeError = "error";
					formError = true;
				} else {
					item.returnReasonCodeError = ""
				}
			}
		});
		self.props.setRequestReturnDetails(orderDetails);

		self.setState({
			requestReturnStep2Form
		});

		if(!formError) {
			// update parameters which are added in this step
			// orderDetails.responseObject.items = _.pullAllBy(orderDetails.responseObject.items, [{ item: item }], 'item');
			let items = orderDetails.responseObject.items;
			items.forEach(item => {
				if(item.selected) {
					let temp = "";
					if(item.returnReasonCode.indexOf("|") !== -1) {
						temp = item.returnReasonCode.split("|");
					} else {
						temp = self.getReturnReasoncode(item.reasonCategory, item.returnReasonCode);
						temp = temp.split("|");
					}
					item.returnReason = temp[0];
					item.returnReasonCode = temp[1];
				}
			})
			if(!(orderDetails.responseObject.deliveryMethod == 'I want products picked up' || orderDetails.responseObject.deliveryMethod == 'I will return the products myself'))
				orderDetails.responseObject.oldShipMethod = orderDetails.responseObject.deliveryMethod
			orderDetails.responseObject = {
				...orderDetails.responseObject,
				...self.state.requestReturnStep2Form.params,
				items,
			}
			let { shippingAddress } = orderDetails.responseObject;
			shippingAddress = shippingAddress ? JSON.parse(shippingAddress) : {};
			orderDetails.responseObject.shippingAddress = {
				name: shippingAddress.NAME,
				address1: shippingAddress.ADDRESS1,
				address2: "",
				city: shippingAddress.CITY,
				state: shippingAddress.STATE,
				zip: shippingAddress.POSTALCODE,
				phone: '',
				addressId: shippingAddress.SITE_USE_ID,
			};
			// get restocking data
			const payload = JSON.parse(JSON.stringify(orderDetails));
			payload.responseObject.items = payload.responseObject.items.filter(item => item.selected === true);
			self.props.getRestockingFee(payload.responseObject, 'requestType=getRestockingFee', resp => {
				if(resp.status) {
					const responseObject = resp.responseObject && resp.responseObject.items;
					orderDetails.responseObject.items.forEach(itm => {
						const data = _.find(responseObject, {item: itm.item});
						if(data) {
							itm.restockingFee = data.restockFee;
						}
					});
					self.props.setRequestReturnDetails(orderDetails);
					browserHistory.push("/requestreturnstep3");
				} else {
					browserHistory.push("/error");
				}
			});
		}
	}

	checkASMOrIsInDL() {
		const self = this;
		const { userDetails } = self.props.user;
		let showRestockingCheckbox = false;
		if(userDetails) {
			showRestockingCheckbox = userDetails.isInDL || userDetails.isASM;
		}
		return showRestockingCheckbox;
	}

	handleCallBackAfterAddedNewAddress(data, addressCreated) {
		const self = this,
			pickingUpAddressList = self.state.pickingUpAddressList;
		if(!pickingUpAddressList.find(item => item.ADDRESS1 === data.address1 && item.CITY === data.city && item.STATE === data.state && item.POSTALCODE.indexOf(data.zipCode) === 0)) {
			pickingUpAddressList.push({
				ADDRESS1: data.address1,
				CITY: data.city,
				STATE: data.state,
				POSTALCODE: data.zipCode
			});
		}
		self.setState({
			showAddShippingAddressOverlayDialog: false,
			pickingUpAddressList,
			requestReturnStep2Form: {
				...self.state.requestReturnStep2Form,
				params: {
					...self.state.requestReturnStep2Form.params,
					shippingAddress: JSON.stringify({
						ADDRESS1: data.address1,
						CITY: data.city,
						STATE: data.state,
						POSTALCODE: data.zipCode,
					})
				}
			}
		}, () => {
			const selectedZipCode = data.zipCode;
			self.props.getShippingAddressesDetails(selectedZipCode.split('-')[0], false, "return_loc", (resp) => {
				const { shippingAddressDetailsListWithZipCode } = this.props.user;
				if(shippingAddressDetailsListWithZipCode.length > 0){
					const foundSdsWillCall = shippingAddressDetailsListWithZipCode[shippingAddressDetailsListWithZipCode.length-1].details.find(item => {
						return item.loctype == "sds_will_call_loc"
					});
					if(foundSdsWillCall){
						this.setState({
							showReturnMyself:true
						})
					}else{
						this.setState({
							showReturnMyself:false
						})
					}
				}
				let warehouseCode = resp && resp.agentid,
					returnToAddress = '';
				// if(self.state.requestReturnStep2Form.params.shippingMethod === 'Meet Truck' || self.state.requestReturnStep2Form.params.shippingMethod === 'SDS Delivery') {
				// 	warehouseCode = self.state.requestReturnStep2Form.params.warehouseCode;
				// }
				if(resp && resp.agentid) {
					returnToAddress = {
						name: resp.dockname,
						address1: resp.dockaddr,
						address2: "",
						city: resp.dockcity,
						state: resp.dockst,
						zip: resp.dockzip,
						phone: resp.dockphone,
						warehouseCodeMessage : resp.locationAddressErrorMessage ==  WARE_HOUSE_CODE_ERROR_MESSAGE ? WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE : ""
					};
				} else {
					returnToAddress = '';
					//if(!(self.state.requestReturnStep2Form.params.shippingMethod === 'Meet Truck' || self.state.requestReturnStep2Form.params.shippingMethod === 'SDS Delivery')) {
						warehouseCode = '';
					//}
				}
				const orderDetails = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
				let shipAddress = JSON.parse(self.state.requestReturnStep2Form.params.shippingAddress)
				if(shipAddress){
					orderDetails.shippingAddress = {
						name: shipAddress.NAME,
						address1: shipAddress.ADDRESS1,
						address2: "",
						city: shipAddress.CITY,
						state: shipAddress.STATE,
						zip: shipAddress.POSTALCODE,
						phone: '',
						addressId: shipAddress.SITE_USE_ID,
					};
					this.resetSelectedServices()
				}
				self.setState({
					requestReturnStep2Form: {
						...self.state.requestReturnStep2Form,
						params: {
							...self.state.requestReturnStep2Form.params,
							warehouseCode,
							returnToAddress
						}
					}
				});
			},true,data.state);
		});
	}

	getReturnReasoncode(reasonCategory, returnReasonCode) {
		const self = this;
		const returnTypeDropdownOptions = self.props.order.returnTypeDropdownValues;
		const returnReasonCodeDropdownOptions = _.find(returnTypeDropdownOptions, ['label', reasonCategory]);
		let selectedValue = "";
		returnReasonCodeDropdownOptions && returnReasonCodeDropdownOptions.values.forEach(item => {
			if(returnReasonCode.indexOf(item.value) !== -1) {
				selectedValue = item.label + "|" + item.value;
			}
		});
		return selectedValue;
	}

	handleShowModalAddSerialNumber(selectedIndex, data, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			selectedSerialNumber: data.serialNumber,
			originalSerialNumbers: data.originalSerialNumbers,
			selectedIndex
		}, () => {
			self.handleDialog("ModalAddSerialNumberOverlayDialog", true);
		});
	}

	handleCallbackAfterSelect(selectedSerialNumber) {
		const self = this;
		const orderDetails = self.props.order.requestReturnDetails;
		orderDetails.responseObject.items[self.state.selectedIndex].serialNumber = selectedSerialNumber;
		orderDetails.responseObject.items[self.state.selectedIndex].serialNumberError = '';
		self.props.setRequestReturnDetails(orderDetails);
		self.handleDialog("ModalAddSerialNumberOverlayDialog", false);
	}

	handleSearchByStoreNumberOrLocation = e => {
		e.preventDefault();
		this.handleDialog('AddressSearchDialog', true);
	};

	handleAddressSelection = address => {
		const foundAddress = this.state.pickingUpAddressList.find(existingAddress => existingAddress.SITE_USE_ID === address.SITE_USE_ID);

		if (foundAddress) {
			this.onChangeUpdateParam({ target: { name: 'shippingAddress', value: foundAddress.SITE_USE_ID }});
		} else {
			this.setState({
				pickingUpAddressList: [...this.state.pickingUpAddressList, address]
			}, () => {
				this.onChangeUpdateParam({ target: { name: 'shippingAddress', value: address.SITE_USE_ID }});
			})
		}
		this.handleDialog('AddressSearchDialog', false);
	};

    render() {
		const self = this;
		const orderDetails = self.props.order.requestReturnDetails && self.props.order.requestReturnDetails.responseObject;
		const orderHeaderAttribute = self.props.order.requestReturnList && self.props.order.requestReturnList.responseObject[0];
		const accessoryList = self.props.order.requestReturnPimdata.filter(item=>item.geego_accessory_indicator == "Y").map(filteredItem => filteredItem.product_attr_val_disp);
		const {
			pickingUpAddressList,
			requestReturnStep2Form: {
				params: {
					shippingMethod
				}
			}
		} = self.state;
		const shippingAddress = self.state.requestReturnStep2Form.params.shippingAddress?JSON.parse(self.state.requestReturnStep2Form.params.shippingAddress):null;
		const returnToAddress = self.state.requestReturnStep2Form.params.returnToAddress;
		const { allowedCustomerClassCodes } = self.props.order,
		{ selectedAccount} = self.props.user,
		customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
		typeOfAccount = self.props.getSelectedAccountType();
		const job =orderHeaderAttribute && orderHeaderAttribute.orderHeader.attributes.attribute.filter((itm)=>itm.name === "Attribute19");
		const lot =orderHeaderAttribute && orderHeaderAttribute.orderHeader.attributes.attribute.filter((itm)=>itm.name === "Attribute20");
      
     return (
			<div>
				<div className="push m-3">
					<h1 className="pageTitle">Request Return</h1>
				</div>
				<form className="returnProductsForm d-none d-sm-block" onSubmit={this.handleSubmitStep2.bind(this)} name="returnProductsForm" id="returnProductsForm">
					<div className="push">
						<table className="formTableTypeA">
							<tbody>
								<tr>
									<td>Return Date</td>
									<td>{this.state.requestReturnStep2Form.params.orderDate}</td>
								</tr>
								<tr>
									<td>Order Type</td>
									<td>{this.state.requestReturnStep2Form.params.orderType}</td>
								</tr>
								<tr>
									<td>JOB</td>
									<td>{job[0].value !== "" ? job[0].value:""}</td>
								</tr>
								<tr>
									<td>LOT</td>
									<td>{lot[0].value !== "" ? lot[0].value:""}</td>
								</tr>
								<tr>
									<td>Return Method</td>
									<td>
										<select name="deliveryMethod" id="returnRequestMethodMenu" value={self.state.requestReturnStep2Form.params.deliveryMethod} onChange={this.onChangeUpdateParam.bind(this)}>
											<option value="I want products picked up">I want products picked up</option>
											{self.state.showReturnMyself?<option value="I will return the products myself">I will return the products myself</option>:""}
										</select>
									</td>
								</tr>
								<tr>
									<td>
										P.O.<br />
										<i className="unbold">(for your reference)</i>
									</td>
									<td>
										<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={'txt-uppercase ' + this.state.requestReturnStep2Form.errors.poNumberError} type="text" name="poNumber" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.poNumber} maxLength={50} />
									</td>
								</tr>
								<tr>
									<td>
										Restocking P.O.
									</td>
									<td>
									<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={'txt-uppercase ' + this.state.requestReturnStep2Form.errors.restockingPoNumError} type="text" name="restockingPoNum" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.restockingPoNum} maxLength={50} />
									</td>
								</tr>
								{this.state.requestReturnStep2Form.params.deliveryMethod && pickingUpAddressList.length > 0 &&
									<tr className="forPickupRequestsOnly" id="addressDetails">
										<td>
											{this.state.requestReturnStep2Form.params.deliveryMethod === 'I want products picked up'
												?'Pick Up Address'
												:'Return From'
											}
										</td>
										<td>
											<select name="shippingAddress" onChange={this.onChangeUpdateParam.bind(this)} value={shippingAddress.SITE_USE_ID||''}>									
												{pickingUpAddressList
												.slice()
												.sort((a,b)=>{
												  const addressA= (a && a.ADDRESS1)?(a.ADDRESS1).toLowerCase():'';
												  const addressB= (b && b.ADDRESS1)?(b.ADDRESS1).toLowerCase():'';
												  return addressA.localeCompare(addressB);
												})
												.map((itm, ind) => {
													const list = [];
													if(itm.ADDRESS1) list.push(itm.ADDRESS1);
													if(itm.CITY) list.push(itm.CITY);
													if(itm.STATE) list.push(itm.STATE);
													if(itm.LOCATION) list.push(itm.LOCATION);
													return <option key={ind} value={itm.SITE_USE_ID}>
														{list.join(', ')}
													</option>
												})}
											</select>
											{shippingAddress && <p className="shippingAddress">
												{shippingAddress.ADDRESS1 && shippingAddress.ADDRESS1.trim()}
												{shippingAddress.ADDRESS1 && shippingAddress.ADDRESS1.trim() !== ""?<br/>:null}
												{shippingAddress.ADDRESS2 && shippingAddress.ADDRESS2.trim()}
												{shippingAddress.ADDRESS2 && shippingAddress.ADDRESS2.trim() !== ""?<br/>:null}
												{shippingAddress.ADDRESS3 && shippingAddress.ADDRESS3.trim()}
												{shippingAddress.ADDRESS3 && shippingAddress.ADDRESS3.trim() !== ""?<br/>:null}
												{shippingAddress.CITY && shippingAddress.CITY.trim()}, {shippingAddress.STATE && shippingAddress.STATE.trim()} {shippingAddress.POSTALCODE && shippingAddress.POSTALCODE.trim()}<br />
												{self.state.requestReturnStep2Form.params.phoneNumber}
											</p>}
											<p>
												<a href="" onClick={this.handleDialog.bind(this, "AddShippingAddressOverlayDialog", true)}>
													Add {this.state.requestReturnStep2Form.params.deliveryMethod === 'I want products picked up'?'Pick Up':'Return From'} Address
												</a>
												<a className="block" href="" onClick={this.handleSearchByStoreNumberOrLocation} style={{ marginTop: '.5rem' }}>
													Search by Store Number or Location
												</a>
											</p>
										</td>
									</tr>
								}
								<tr>
									<td>
										Return to Location
									</td>
									<td>
										{returnToAddress
											? <p className="shippingAddress">
												{returnToAddress.warehouseCodeMessage  && <React.Fragment><strong className="red bold">{returnToAddress.warehouseCodeMessage}</strong><br /></React.Fragment>}
												{returnToAddress.name && returnToAddress.name.trim()}<br />
												{returnToAddress.address1 && returnToAddress.address1.trim()}
												{returnToAddress.address1 && returnToAddress.address1.trim() !== ""?<br/>:null}
												{returnToAddress.city && returnToAddress.city.trim()}, {returnToAddress.state && returnToAddress.state.trim()} {returnToAddress.zip && returnToAddress.zip.trim()}<br />
												{self.props.normalizePhoneNumber(returnToAddress.phone)}<br />
											</p>
											: <p className="red bold">Return Location not found</p>
										}
									</td>
								</tr>
								<tr className="forPickupRequestsOnly" >
									<td>
										{this.state.requestReturnStep2Form.params.deliveryMethod === "I want products picked up"
											?'Pick Up Phone Number'
											:'Phone Number'
										}
									</td>
									<td>
										<input onKeyPress={this.props.acceptNumbersOnly} onBlur={this.onBlurValidatePhoneNumber.bind(this)} className={"phoneNumberField "+this.state.requestReturnStep2Form.errors.deliveryPhoneError} type="text" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.deliveryPhone} name="deliveryPhone" size={17} maxLength={17} />
									</td>
								</tr>
								{this.state.requestReturnStep2Form.params.deliveryMethod === "I want products picked up" &&
									<tr className="forPickupRequestsOnly">
										<td>Pick Up Instructions</td>
										<td className="containingTextArea">
											<textarea rows={6} cols={40} defaultValue={this.state.requestReturnStep2Form.params.deliveryInstructions} onChange={this.onChangeUpdateParam.bind(this)} name="deliveryInstructions" />
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div> {/* / .push */}
					<div className="push">
						<table className="dataTableType2 returnProductsTable">
							<thead>
								<tr>
									<th className="remove">Remove</th>
									<th className="productToReturn">Product</th>
									<th className="quantityToReturn">Qty</th>
									<th className="invoiceNumber">Invoice #</th>
									<th className="serialNumber">Return Type</th>
									<th className="reasonForReturn">Reason For Return Request</th>
									{(shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL') && <th>Replacement<br/>Needed?</th>}
									{!self.state.returnProductsMyself && <th className="delCrate">Crated/<br/>Uncrated</th>}
									{(orderDetails.deliveryMethod === 'SDS Delivery' || orderDetails.deliveryMethod === 'SDS Delivery Next Day' || orderDetails.deliveryMethod === 'I want products picked up' || orderDetails.deliveryMethod === "I will return the products myself") && !self.state.returnProductsMyself
										?<th className="services">Add<br/>Services</th>
										:null
									}
								</tr>
							</thead>
							<tbody>
								{orderDetails && orderDetails.items.map((item, index) => {
									let accessoryListflag =false;
									if( accessoryList.includes(item.item) ){
										accessoryListflag =true;
									}
									if(!item.selected) return null;
									const returnTypeDropdownOptions = self.props.order.returnTypeDropdownValues;
									const returnReasonCodeDropdownOptions = _.filter(returnTypeDropdownOptions, ['label', item.reasonCategory]);
									 let isContractService = item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0;
									 const itemLevelDisableUncrateDropdown = (allowedCustomerClassCodes.indexOf(customerClassCode) !== -1 || typeOfAccount === "RETAIL")
									 && item.uncrateInd === 'N' ? true : false;
									return [
										<tr key={100 + index}>
											<td className="remove" style={{borderBottom: '0 none'}}>
												<a className="deleteLink" href="" onClick={this.onDeleteItem.bind(this, index)} >✗</a>
											</td>
											<td className="productToReturn" style={{borderBottom: '0 none'}}>
												{item.internalItem}
											</td>
											<td className="quantityToReturn" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
											<td className="invoiceNumber" style={{borderBottom: '0 none'}}>{item.invoiceNumber}</td>
											<td className="reasonForReturn" style={{borderBottom: '0 none'}}>
												<select className={"reasonCategory " + item.reasonCategoryError} defaultValue={item.reasonCategory} onChange={this.onChangeUpdateItems.bind(this, index)} name="reasonCategory">
													<option value="">Select</option>
													{returnTypeDropdownOptions.map((it, ind) => {
														return <option key={ind} value={it.label}>{it.label}</option>
													})}
												</select>
											</td>
											<td className="reasonForReturn" style={{borderBottom: '0 none'}}>
												<select className={"reasonForReturnRequest " + item.returnReasonCodeError} defaultValue={this.getReturnReasoncode(item.reasonCategory, item.returnReasonCode)} onChange={this.onChangeUpdateItems.bind(this, index)} name="returnReasonCode" disabled={returnReasonCodeDropdownOptions.length === 0?true:false}>
													<option value="">Select</option>
													{returnReasonCodeDropdownOptions.length > 0 && returnReasonCodeDropdownOptions[0].values.map((it, ind) => {
														return <option key={ind} value={it.label+"|"+it.value}>{it.label}</option>
													})}
												</select>
											</td>
											{shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL'  && <td style={{borderBottom: '0 none'}}>
												<input type="checkbox" onChange={this.onChangeUpdateItems.bind(this, index)} name="replacementNeeded" defaultChecked={item.replacementNeeded} disabled = {isContractService} />
											</td>}
											{!self.state.returnProductsMyself && <td className="delCrate" style={{borderBottom: '0 none'}}>
												 {this.showCratedColumn(item,index)  && <select
													name="uncrateInd"
													onChange={this.onChangeUpdateItems.bind(this, index)}
													value={item.uncrateInd}
													disabled={itemLevelDisableUncrateDropdown}
												>
													<option value="N">Crated</option>
													<option value="Y">Uncrated</option>
												</select>} 
		                                    </td>}
											{(orderDetails.deliveryMethod === 'SDS Delivery' || orderDetails.deliveryMethod === 'SDS Delivery Next Day' || orderDetails.deliveryMethod === 'I want products picked up' || orderDetails.deliveryMethod === "I will return the products myself" || orderDetails.deliveryMethod === "Meet Truck") && !self.state.returnProductsMyself
												? <td className="services" style={{borderBottom: '0 none'}}>
													{this.showServicesColumn(item, itemLevelDisableUncrateDropdown,index)
			                                        	? <a className="servicesLink" onClick={this.handleAddServices.bind(this, index, item.item, itemLevelDisableUncrateDropdown)}  href="">
															<img className="icon" src="../images/icon-services-large.png" width={27} height={27} alt="Add Services" title="Add Services" />
														</a>
														:null
													}
			                                    </td>
												:null
											}
										</tr>,
										item.relatedServices ? item.relatedServices.map((itm, ind) => {
																if(itm.type === "BAG") 
																	return null;
																return <tr key={400 + ind}>
																			<td className="remove" style={{borderBottom: '0 none'}}>
																				<a className="deleteLink" href="" onClick={this.handleActionChangeService.bind(this, index, itm.serviceId)} >✗</a>
																			</td>
																			<td className="productToReturn" style={{borderBottom: '0 none'}}>
																					&nbsp; &nbsp; {itm.serviceId}
																			</td>
																			<td className="quantityToReturn" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
																		</tr>
																		}) : null,
										item.originalSerialNumbers && <tr key={200 + index}>
											<td colSpan={ (shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL') ? 9 : 5 } style={{paddingTop: 0}}>
												<div style={{marginTop: '.5rem'}}>
													<a
														href=""
														onClick={this.handleShowModalAddSerialNumber.bind(this, index, item)}
														className="bold js--add-serial"
														style={{float: 'left'}}
													>+ Add Serial Number(s)</a>
													<span style={{marginLeft: '1rem', color: 808080, float: 'left'}}>
														{item.serialNumber && item.serialNumber.split(" ").join(", ")}
														{item.serialNumberError && !item.serialNumber && <span className="red bold">Please select Serial Numbers.</span>}
														{item.serialNumberError && item.serialNumber && (item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) && <span className="red bold"><br /><br />Please select the correct number of serials for the quantity being returned.</span>}
													</span>
												</div>
											</td>
										</tr>,
										!item.originalSerialNumbers && !accessoryListflag && <tr key={300 + index}>
											<td className="text-right">
												Enter Serial # (s)
											</td>
											<td colSpan={ (shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL') ? 9 : 4 }>
												<input type="text" className={"notesAboutReturn " + item.serialNumberError} onChange={this.onChangeUpdateItems.bind(this, index)} name="serialNumber" defaultValue={item.serialNumber} placeholder="Ex. AA123456, AA101234" style={{width: '95%'}} />
												{item.serialNumberError && item.serialNumber &&
													<span className="red bold"><br /><br />Please enter the correct number of serials, separate by commas, for the quantity being returned.</span>
												}
											</td>
										</tr>
									]
								})}
							</tbody>
						</table>
					</div>
					<p className="textRight">
						<input type="submit" value="Review Return Request" />
					</p>
				</form>	{/* / .returnProductsForm#returnProductsForm */}
				<form className="d-block d-sm-none" onSubmit={this.handleSubmitStep2.bind(this)} name="returnProductsForm" id="returnProductsForm">
					<div className="push m-3">
						<table className="formTableTypeAMain">
							<tbody>
								<tr>
									<td>Return Date <p className="formTableTypeAInner">{this.state.requestReturnStep2Form.params.orderDate}</p></td>
								</tr>
								<tr>
									<td>Order Type <p className="formTableTypeAInner">{this.state.requestReturnStep2Form.params.orderType}</p></td>
								</tr>
								<tr>
									<td>JOB <p className="formTableTypeAInner">{job[0].value !== "" ? job[0].value:""}</p></td>
								</tr>
								<tr>
									<td>LOT <p className="formTableTypeAInner">{lot[0].value !== "" ? lot[0].value:""}</p></td>
								</tr>
								<tr>
									<td>Return Method
									<div>
									<select name="deliveryMethod"  className="py-1" id="returnRequestMethodMenu" value={self.state.requestReturnStep2Form.params.deliveryMethod} onChange={this.onChangeUpdateParam.bind(this)}>
											<option value="I want products picked up">I want products picked up</option>
											{self.state.showReturnMyself?<option value="I will return the products myself">I will return the products myself</option>:""}
										</select>
									</div>
									</td>
								</tr>
								<tr>
									<td>
										P.O.<br />
										<i className="unbold">(for your reference)</i>
									<div>
									<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={`txt-uppercase py-1 ` + this.state.requestReturnStep2Form.errors.poNumberError} type="text" name="poNumber" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.poNumber} maxLength={50} />
									</div>
									</td>
								</tr>
								<tr>
									<td>
										Restocking P.O.
									<div>
									<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={`txt-uppercase py-1 ` + this.state.requestReturnStep2Form.errors.restockingPoNumError} type="text" name="restockingPoNum" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.restockingPoNum} maxLength={50} />
									</div>
									</td>
								</tr>
								{this.state.requestReturnStep2Form.params.deliveryMethod && pickingUpAddressList.length > 0 &&
									<tr>
										<td>
											{this.state.requestReturnStep2Form.params.deliveryMethod === 'I want products picked up'
												?'Pick Up Address'
												:'Return From'
											}

										<div>
										<select name="shippingAddress" style={{width:"75%"}} className='py-1' onChange={this.onChangeUpdateParam.bind(this)} value={shippingAddress.SITE_USE_ID||''}>
												{pickingUpAddressList
												.slice()
												.sort((a,b)=>{
												  const addressA= (a && a.ADDRESS1)?(a.ADDRESS1).toLowerCase():'';
												  const addressB= (b && b.ADDRESS1)?(b.ADDRESS1).toLowerCase():'';
												  return addressA.localeCompare(addressB);
												})
												.map((itm, ind) => {
													const list = [];
													if(itm.ADDRESS1) list.push(itm.ADDRESS1);
													if(itm.CITY) list.push(itm.CITY);
													if(itm.STATE) list.push(itm.STATE);
													if(itm.LOCATION) list.push(itm.LOCATION);
													return <option key={ind} value={itm.SITE_USE_ID}>
														{list.join(', ')}
													</option>
												})}
											</select>
											{orderDetails.shippingAddress && <p className="shippingAddress fw-lighter">
												{orderDetails.shippingAddress.address1 && orderDetails.shippingAddress.address1.trim()}
												{orderDetails.shippingAddress.address1 && orderDetails.shippingAddress.address1.trim() !== ""?<br/>:null}
												{orderDetails.shippingAddress.address2 && orderDetails.shippingAddress.address2.trim()}
												{orderDetails.shippingAddress.address2 && orderDetails.shippingAddress.address2.trim() !== ""?<br/>:null}
												{orderDetails.shippingAddress.address3 && orderDetails.shippingAddress.address3.trim()}
												{orderDetails.shippingAddress.address3 && orderDetails.shippingAddress.address3.trim() !== ""?<br/>:null}
												{orderDetails.shippingAddress.city && orderDetails.shippingAddress.city.trim()}, {orderDetails.shippingAddress.state && orderDetails.shippingAddress.state.trim()} {orderDetails.shippingAddress.zip && orderDetails.shippingAddress.zip.trim()}<br />
												{self.state.requestReturnStep2Form.params.phoneNumber}
											</p>}
											<p>
												<a href="" onClick={this.handleDialog.bind(this, "AddShippingAddressOverlayDialog", true)}>
													Add {this.state.requestReturnStep2Form.params.deliveryMethod === 'I want products picked up'?'Pick Up':'Return From'} Address
												</a>
												<a className="block" href="" onClick={this.handleSearchByStoreNumberOrLocation} style={{ marginTop: '.5rem' }}>
													Search by Store Number or Location
												</a>
											</p>
											</div>
										</td>
									</tr>
								}
								<tr>
									<td>
										Return to Location
									<div>
										{returnToAddress
										? <p className="shippingAddress fw-lighter">
												{returnToAddress.warehouseCodeMessage  && <React.Fragment><strong className="red bold">{returnToAddress.warehouseCodeMessage}</strong><br /></React.Fragment>}
												{returnToAddress.name && returnToAddress.name.trim()}<br />
												{returnToAddress.address1 && returnToAddress.address1.trim()}
												{returnToAddress.address1 && returnToAddress.address1.trim() !== ""?<br/>:null}
												{returnToAddress.city && returnToAddress.city.trim()}, {returnToAddress.state && returnToAddress.state.trim()} {returnToAddress.zip && returnToAddress.zip.trim()}<br />
												{self.props.normalizePhoneNumber(returnToAddress.phone)}<br />
											</p>
											: <p className="red bold">Return Location not found</p>
										}
										</div>
									</td>
								</tr>
								<tr >
									<td>
										{this.state.requestReturnStep2Form.params.deliveryMethod === "I want products picked up"
											?'Pick Up Phone Number'
											:'Phone Number'
										}
										<div>
										<input onKeyPress={this.props.acceptNumbersOnly} onBlur={this.onBlurValidatePhoneNumber.bind(this)} className={`phoneNumberField py-1 `+this.state.requestReturnStep2Form.errors.deliveryPhoneError} type="text" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestReturnStep2Form.params.deliveryPhone} name="deliveryPhone" size={17} maxLength={17} />
										</div>
									</td>
								</tr>
								{this.state.requestReturnStep2Form.params.deliveryMethod === "I want products picked up" &&
									<tr>
										<td>Pick Up Instructions
										<div className="containingTextArea">
											<textarea rows={6} cols={40} placeholder="Text here" defaultValue={this.state.requestReturnStep2Form.params.deliveryInstructions} onChange={this.onChangeUpdateParam.bind(this)} name="deliveryInstructions" />
										</div>
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div> {/* / .push */}
					{orderDetails && orderDetails.items.map((item, index) => {
									let accessoryListflag =false;
									if( accessoryList.includes(item.item) ){
										accessoryListflag =true;
									}
									if(!item.selected) return null;
									const returnTypeDropdownOptions = self.props.order.returnTypeDropdownValues;
									const returnReasonCodeDropdownOptions = _.filter(returnTypeDropdownOptions, ['label', item.reasonCategory]);
									 let isContractService = item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0;
									 const itemLevelDisableUncrateDropdown = (allowedCustomerClassCodes.indexOf(customerClassCode) !== -1 || typeOfAccount === "RETAIL")
									 && item.uncrateInd === 'N' ? true : false;
									 return  <div className="accordion accordion-borderless" id={`accordionRequestReturn1${index}`}  key={index}>
									 <div>
										 <h2 className="accordion-header" id={`flush-requestReturn1${index}`}>
										 <button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOneRR${index}`} aria-expanded="true" aria-controls={`flush-collapseOneRR${index}`}>
											{`PRODUCT`} {item.internalItem}
										</button>
										</h2>
										<div id={`flush-collapseOneRR${index}`} className="accordion-collapse collapse show" aria-labelledby={`flush-requestReturn1${index}`} data-bs-parent={`#accordionRequestReturn1${index}`}>
												<table className='orderTable'>
													<tbody>
														{<tr className='border-bottom'>
															<td className='p-3'>{' '}</td>
																{item.originalSerialNumbers && <tr key={200 + index}>
																	<td colSpan={ (shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL') ? 9 : 5 } style={{paddingTop: 0}}>
																		<div style={{marginTop: '.5rem'}}>
																			<a
																				href=""
																				onClick={this.handleShowModalAddSerialNumber.bind(this, index, item)}
																				className="bold js--add-serial"
																				style={{float: 'left'}}
																			>+ Add Serial Number(s)</a>
																			<span style={{marginLeft: '1rem', color: 808080, float: 'left'}}>
																				{item.serialNumber && item.serialNumber.split(" ").join(", ")}
																				{item.serialNumberError && !item.serialNumber && <span className="red bold">Please select Serial Numbers.</span>}
																				{item.serialNumberError && item.serialNumber && (item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) && <span className="red bold"><br /><br />Please select the correct number of serials for the quantity being returned.</span>}
																			</span>
																		</div>
																	</td>
																</tr>}
														</tr>}
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>QUANTITY</td>
															<td className="quantityToReturn" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>INVOICE #</td>
															<td className="invoiceNumber" style={{borderBottom: '0 none'}}>{item.invoiceNumber}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>RETURN TYPE</td>
															<td className="reasonForReturn" style={{borderBottom: '0 none'}}>
															<select className={`reasonCategory py-1 ` + item.reasonCategoryError} defaultValue={item.reasonCategory} onChange={this.onChangeUpdateItems.bind(this, index)} name="reasonCategory">
																	<option value="">Select</option>
																	{returnTypeDropdownOptions.map((it, ind) => {
																		return <option key={ind} value={it.label}>{it.label}</option>
																	})}
																</select>
															</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>REASON FOR RETURN REQUEST</td>
															<td className="reasonForReturn" style={{borderBottom: '0 none'}}>
															<select className={`reasonForReturnRequest py-1 `+ item.returnReasonCodeError} defaultValue={this.getReturnReasoncode(item.reasonCategory, item.returnReasonCode)} onChange={this.onChangeUpdateItems.bind(this, index)} name="returnReasonCode" disabled={returnReasonCodeDropdownOptions.length === 0?true:false}>
																	<option value="">Select</option>
																	{returnReasonCodeDropdownOptions.length > 0 && returnReasonCodeDropdownOptions[0].values.map((it, ind) => {
																		return <option key={ind} value={it.label+"|"+it.value}>{it.label}</option>
																	})}
																</select>
															</td>
														</tr>
														<tr className='border-bottom'>
															{(shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL') && <td className='p-3 fw-bold'>REPLACEMENT<br/>NEEDED?</td>}
															{shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && shippingMethod !== 'ADC LTL'  && <td style={{borderBottom: '0 none'}}>
																<input type="checkbox" onChange={this.onChangeUpdateItems.bind(this, index)} name="replacementNeeded" defaultChecked={item.replacementNeeded} disabled = {isContractService} />
															</td>}
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>CRATED/UNCRATED</td>
															{!self.state.returnProductsMyself && <td className="delCrate" style={{borderBottom: '0 none'}}>
															{this.showCratedColumn(item,index)  && <select className='py-1'
																	name="uncrateInd"
																	onChange={this.onChangeUpdateItems.bind(this, index)}
																	value={item.uncrateInd}
																	disabled={itemLevelDisableUncrateDropdown}
																>
																	<option value="N">Crated</option>
																	<option value="Y">Uncrated</option>
																</select>} 
															</td>}
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>ADD SERVICES</td>
															{(orderDetails.deliveryMethod === 'SDS Delivery' || orderDetails.deliveryMethod === 'SDS Delivery Next Day' || orderDetails.deliveryMethod === 'I want products picked up' || orderDetails.deliveryMethod === "I will return the products myself" || orderDetails.deliveryMethod === "Meet Truck") && !self.state.returnProductsMyself
																? <td className="services" style={{borderBottom: '0 none'}}>
																	{this.showServicesColumn(item, itemLevelDisableUncrateDropdown,index)
																		? <a className="servicesLink" onClick={this.handleAddServices.bind(this, index, item.item, itemLevelDisableUncrateDropdown)}  href="">
																			<img className="icon" src="../images/icon-services-large.png" width={27} height={27} alt="Add Services" title="Add Services" />
																		</a>
																		:null
																	}
																</td>
																:null
															}
														</tr>
														<tr>
															<td className='p-3 fw-bold'>REMOVE</td>
															<td className="remove" style={{borderBottom: '0 none'}}>
																<a className="deleteLink" href="" onClick={this.onDeleteItem.bind(this, index)} >✗</a>
															</td>
														</tr>
													</tbody>
												</table>
										</div>
									</div>
									</div>
					})}
					<p className="textRight">
						<input type="submit" value="Review Return Request" />
					</p>
				</form>
				{this.state.showAddShippingAddressOverlayDialog?<AddShippingAddressOverlayDialog showOtherFieldsInAddShippingAddress={this.props.showOtherFieldsInAddShippingAddress} handleDialog={this.handleDialog} existingAddresses={this.state.addressList} handleCallBackAfterAddedNewAddress={this.handleCallBackAfterAddedNewAddress.bind(this)} showDialog={true} />:null }
				{this.state.showModalAddSerialNumberOverlayDialog
					?
					<ModalAddSerialNumberOverlayDialog
						serialNumber={self.state.selectedSerialNumber}
						originalSerialNumbers={self.state.originalSerialNumbers}
						handleCallbackAfterSelect={this.handleCallbackAfterSelect.bind(this)}
						handleDialog={this.handleDialog}
						showDialog={true}
					/>
					:null
				}
				{this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog}
						itemLevelDisableUncrateDropdown={this.state.itemLevelDisableUncrateDropdown}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.props.order.requestReturnDetails.responseObject.items}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
						requiredPayloadForServicePricing={this.state.requiredPayloadForServicePricing}
					/>
				:null }
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showPriceSourceOverlayDialog?
					<PriceSourceOverlayDialog
						isResponsibilityExists={this.props.isResponsibilityExists}
						formatMoney={this.props.formatMoney}
						selectedItem={this.state.selectedItem}
						orderDate={this.props.order.requestReturnDetails.responseObject.orderDate}
						selectedAccountsAllPriceSources={this.props.user.selectedAccountsAllPriceSources}
						priceSource={this.state.selectedPriceSource}
						showDialog={true}
						handleDialog={this.handleDialog}
						typeOfAccount={this.props.getSelectedAccountType()}
					/>:null}
				{this.state.showAddressSearchDialog && <AddressSearchDialog getCombinedAddresses={this.props.getCombinedAddresses} onConfirm={this.handleAddressSelection} onClose={this.handleDialog.bind(this, 'AddressSearchDialog', false)} />}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestReturnDetails: (data) => dispatch(setRequestReturnDetails(data)),
	getRestockingFee: (payload, params, response) => dispatch(getRestockingFee(payload, params, response)),
	getShippingAddresses: (queryStringParams, showLoader, callback) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback)),
	getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
	saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
});

RequestReturnStep2 = connect(mapStateToProps, mapDispatchToProps)(RequestReturnStep2);
export default RequestReturnStep2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/requestReturnStep2.js